/* eslint 'react/jsx-props-no-spreading': 0 */
import React from 'react';
import { useSwipeable } from 'react-swipeable';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Slide from '@material-ui/core/Slide';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  media: {
    widht: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  indicator: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
    opacity: 0.4,
    cursor: 'pointer',
  },
  activeIndicator: {
    opacity: 1,
  },
  indicatorIcon: {
    margin: theme.spacing(2, 0.5),
    width: theme.typography.pxToRem(20),
    height: theme.typography.pxToRem(4),
    backgroundColor: theme.palette.common.white,
  },
}));

const Carousel = ({
  data = {},
  height = 320,
  width = 1,
  duration = 300,
}) => {
  const classes = useStyles();
  const [index, setIndex] = React.useState(0);
  const numSlides = Object.keys(data).length;

  const [slideIn, setSlideIn] = React.useState(true);
  const [slideDirection, setSlideDirection] = React.useState('down');

  const handleArrowClick = (direction) => {
    const increment = direction === 'left' ? -1 : 1;
    const newIndex = (index + increment + numSlides) % numSlides;

    const oppDirection = direction === 'left' ? 'right' : 'left';
    setSlideDirection(direction);
    setSlideIn(false);

    setTimeout(() => {
      setIndex(newIndex);
      setSlideDirection(oppDirection);
      setSlideIn(true);
    }, duration);
  };

  const handleIndicateClick = (newIndex) => {
    const oppDirection = newIndex > index ? 'right' : 'left';
    setTimeout(() => {
      setIndex(newIndex);
      setSlideDirection(oppDirection);
      setSlideIn(true);
    }, duration);
  };

  const swipeHandler = useSwipeable({
    onSwipedLeft: () => handleArrowClick('right'),
    onSwipedRight: () => handleArrowClick('left'),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 39) {
        handleArrowClick('right');
      }
      if (e.keyCode === 37) {
        handleArrowClick('left');
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  });

  return (
    <Box
      position="relative"
      height={height}
      width={width}
      overflow="hidden"
      className="carousel box"
      style={{ backgroundColor: 'lightgrey' }}
    >
      <Box
        position="absolute"
        width={1}
        height={1}
        top={0}
        left={0}
        {...swipeHandler}
      />
      <Slide
        in={slideIn}
        direction={slideDirection}
      >
        <a
          href={data[index]?.urlToGo}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            style={{ objectFit: 'cover' }}
            width="100%"
            height="100%"
            src={`${data[index]?.imageUrl}`}
            alt=""
          />
        </a>
      </Slide>
      <Box position="absolute" width={width} bottom={0}>
        <Grid container alignItems="center" justify="center">
          {
            Object.keys(data).map((imageKey, imgIndex) => (
              <Grid item key={imageKey}>
                <div
                  className={clsx(classes.indicator, {
                    [classes.activeIndicator]: imageKey === `${index}`,
                  })}
                  aria-hidden="true"
                  onClick={() => handleIndicateClick(imgIndex)}
                >
                  <div className={classes.indicatorIcon} />
                </div>
              </Grid>
            ))
          }
        </Grid>
      </Box>
    </Box>
  );
};

export default Carousel;
